export default "__VITE_ASSET__BoyQH8qr__"